import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {LoaiKeHoach} from '../../../models/danhmuc/loaikehoach';
import {KeHoachService} from '../../../service/kehoach/service-kehoach';
import {KeHoachFileService} from '../../../service/kehoach/service-kehoachfile';
import {LoaiKeHoachService} from '../../../service/danhmuc/service-loaikehoach';
import {Subject} from 'rxjs';
import {UploadDropComponent} from '../../ui/upload/uploaddrop.component';
import {KeHoachFile} from '../../../models/kehoach/kehoachfile';
import {DonViService} from '../../../service/danhmuc/service-donvi';
import {EditKeHoachComponent} from '../../info/kehoach/edit.component';
@Component({
  templateUrl: './edit.component.html'

})
export class EditDonViNoiBoComponent implements OnInit, AfterViewInit {


  private language = language;
  private id: number = 0;
  private frmGroup: FormGroup;
  private isEdit: boolean = false;
  private submitValidate = false;
  public onClose: Subject<boolean>;
  private isSuDung: boolean = true;
  private maCapTren: number =0 ;
  constructor( private donViService: DonViService,
               private formBuilder: FormBuilder,
               private toastr: ToastrService,
               private _bsModalRef: BsModalRef,
               private bsModalService: BsModalService,

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      tenCQ: new FormControl(),
      tenVietTat: new FormControl(''),
      cap: new FormControl(0),
      maCapTren: new FormControl(),
      stt: new FormControl(),
      suDung: new FormControl(),
      hasChild: new FormControl()
    });
    this.frmGroup = this.formBuilder.group({
      id: [0 , Validators.nullValidator ],
      tenCQ: ['' , Validators.compose([validateEmpty]) ],
      tenVietTat: ['', Validators.nullValidator],
      cap: [2, Validators.nullValidator],
      maCapTren: ['0', Validators.nullValidator],
      stt: ['0', Validators.nullValidator],
      suDung: [1, Validators.nullValidator],
      hasChild: [true, Validators.nullValidator],

    });



  }
  get f() { return this.frmGroup.controls; }
  public edit(id: number) {
    this.id = id;
    this.isEdit = true;
    this.donViService.getById(id).pipe(first())
      .subscribe(x => {this.frmGroup.patchValue(x);
        this.isSuDung = x.suDung === 1? true: false;
        this.maCapTren = x.maCapTren;
      });


  }
  public child(id: number) {
    this.maCapTren = id;
  }
  private createItem ()
  {
    this.frmGroup.controls['suDung'].setValue(this.isSuDung == false ? 0: 1);
    this.frmGroup.controls['maCapTren'].setValue(this.maCapTren);
    this.donViService.add(this.frmGroup.value).subscribe(
      {
        next: (data) => {
          this.toastr.success(language.add_success_record, language.message);
          this.onConfirm();
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }
  private updateItem()
  {
    this.frmGroup.controls['suDung'].setValue(this.isSuDung == false ? 0: 1);
    this.frmGroup.controls['maCapTren'].setValue(this.maCapTren);
    this.donViService.update(this.frmGroup.value).subscribe({
      next: (data) => {
        this.toastr.success(language.update_success_record, language.message);
        this.onConfirm();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    if (this.id != 0)
      this.updateItem();
    else
      this.createItem();
  }
  private onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  private onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  private hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

